import React from "react";
import EasyLink from "./easy-link";
import "./activity.scss";
import { ImageFrame } from "./image-frame";
import { Link } from "react-router-dom";

interface ActivityProps {
    imageSource: any;
    activityTitle: string;
    imageTitle: string;
    linkTitle: string;
    link: string;
    isImageBordered?: boolean;
    className?: string;
}

export const Activity = (props: ActivityProps) => {
    return (
        <div className={props.className ? `${props.className} activity` : "activity"}>
            <Link to={props.link} className="activity-title-link">
                <div className="activity-name">{props.activityTitle}</div>
            </Link>
            {
                props.isImageBordered ?
                    <div className="activity-image-bordered">
                        <ImageFrame imageSource={props.imageSource} imageTitle={props.imageTitle} />
                    </div>
                    :
                    <div className="activity-image">
                        <img src={props.imageSource} alt={props.imageTitle} />
                    </div>
            }

            <EasyLink link={props.link} title={props.linkTitle} />
        </div>
    )
}